import { useQuery } from 'react-query';

import { QUERY_KEY_BERRY_SESSION_DETAIL } from 'src/constants';
import { berryApiService } from 'src/services/berry.service';

export default function useBerryGetSession(sessionId: string | null) {
  return useQuery(
    [QUERY_KEY_BERRY_SESSION_DETAIL, sessionId],
    () => berryApiService.getSession(sessionId!),
    { enabled: sessionId !== null, retry: false },
  );
}
